export default __webpack_public_path__ + "static/Montserrat-Light-00b3e893aab5a8fd632d6342eb72551a.woff2";